// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"636":"52ba64b9","787":"482cd46d"}[chunkId] + ".chunk.js";
};